var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.586,
    height: 36.578,
    viewBox: "0 0 36.586 36.578",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-instagram",
    "data-name": "Icon awesome-instagram",
    d: "M18.292,11.149a9.378,9.378,0,1,0,9.378,9.378A9.363,9.363,0,0,0,18.292,11.149Zm0,15.475a6.1,6.1,0,1,1,6.1-6.1,6.108,6.108,0,0,1-6.1,6.1ZM30.241,10.765a2.187,2.187,0,1,1-2.187-2.187A2.182,2.182,0,0,1,30.241,10.765Zm6.211,2.22c-.139-2.93-.808-5.526-2.955-7.664s-4.734-2.808-7.664-2.955c-3.02-.171-12.072-.171-15.092,0-2.922.139-5.518.808-7.664,2.946S.27,10.047.123,12.977C-.048,16-.048,25.049.123,28.068c.139,2.93.808,5.526,2.955,7.664s4.734,2.808,7.664,2.955c3.02.171,12.072.171,15.092,0,2.93-.139,5.526-.808,7.664-2.955S36.306,31,36.452,28.068c.171-3.02.171-12.063,0-15.083Zm-3.9,18.324a6.173,6.173,0,0,1-3.477,3.477c-2.408.955-8.121.735-10.782.735s-8.382.212-10.782-.735a6.173,6.173,0,0,1-3.477-3.477C3.078,28.9,3.3,23.188,3.3,20.527s-.212-8.382.735-10.782A6.173,6.173,0,0,1,7.51,6.268c2.408-.955,8.121-.735,10.782-.735s8.382-.212,10.782.735a6.173,6.173,0,0,1,3.477,3.477c.955,2.408.735,8.121.735,10.782S33.506,28.909,32.551,31.309Z",
    transform: "translate(0.005 -2.238)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.2f3753b837d8cf91143f5c4f195e07cf.svg";
export { ForwardRef as ReactComponent };